import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(4),
    flexDirection: 'column',
  },
  listRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  emailSection: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  actionPart: {
    marginRight: theme.spacing(2),
    fontSize: '14px',
    color: theme.palette.labraText.description,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  email: {
    fontSize: '16px',
    color: theme.palette.labraText.tertiary,
  },
  pending: {
    fontSize: '12px',
    color: theme.palette.labraText.description,
  },
  emptyName: {
    border: `1px dotted ${theme.palette.dividerV2.main}`,
    height: '24px',
    width: '24px',
    borderRadius: '52px',
  },
  avatar: {
    '&.MuiAvatar-root': {
      display: 'flex',
      width: theme.spacing(3),
      height: theme.spacing(3),
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(10 / 8),
      textAlign: 'center',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '16px',
      letterSpacing: '0.5px',
      border: '1px solid transparent',
      color: theme.palette.labraText.tertiary,
      borderRadius: '52px',
      '&:hover': {
        border: `1px solid ${theme.palette.labraText.tertiary}`,
      },
    },
  },
  admin: {
    '&.MuiAvatar-root': {
      background: `linear-gradient(0deg, ${theme.palette.avatarColors.blue} 0%, ${theme.palette.avatarColors.blue} 100%)`,
    },
  },
  user1: {
    '&.MuiAvatar-root': {
      background: `linear-gradient(0deg, ${theme.palette.avatarColors.green} 0%, ${theme.palette.avatarColors.green} 100%)`,
    },
  },
  user2: {
    '&.MuiAvatar-root': {
      background: `linear-gradient(0deg, ${theme.palette.avatarColors.orange} 0%, ${theme.palette.avatarColors.orange} 100%)`,
    },
  },
  user3: {
    '&.MuiAvatar-root': {
      background: `linear-gradient(0deg, ${theme.palette.avatarColors.purple} 0%, ${theme.palette.avatarColors.purple} 100%)`,
    },
  },
}))
